export function splitIntoSubArrays<T>(array: T[], splitSize: number): T[][] {
    const arrayOfArrays = [];
    for (let i = 0; i < array.length; i += splitSize) {
        arrayOfArrays.push(array.slice(i, i + splitSize));
    }
    return arrayOfArrays;
}
